export default __webpack_public_path__ + "static/media/connections.e9b2ea23.png";